export const sidebarConstants = {
  Domain: 'sidebar'
}

export const CREATE = 'create'
export const EDIT = 'edit'
